import { render, staticRenderFns } from "./ChangePaymentFrequency.vue?vue&type=template&id=3a9bc286&"
import script from "./ChangePaymentFrequency.vue?vue&type=script&lang=js&"
export * from "./ChangePaymentFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports